import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {
    StoreState,
    createCompanySlice,
    createCostCenterSlice,
    createDataTableSlice,
    createDateSelectorsSlice,
    createDebugSlice,
    createEmployeeSlice,
    createLocationSlice,
    createTableSettingsSlice,
} from './slices'
import { createLocaisSlice } from './slices/locais'

export const useStore = create<StoreState>()(
    persist(
        (...a) => ({
            customer: null,
            ...createCompanySlice(...a),
            ...createEmployeeSlice(...a),
            ...createCostCenterSlice(...a),
            ...createLocationSlice(...a),
            ...createDateSelectorsSlice(...a),
            ...createLocaisSlice(...a),
            ...createDataTableSlice(...a),
            ...createTableSettingsSlice(...a),
            ...createDebugSlice(...a),
        }),
        {
            name: 'store',
            partialize: state => ({
                employeeId: state.employeeId,
                competence: state.competencia,
                companyId: state.companyId,
                isDebugToolsEnabled: state.isDebugToolsEnabled,
                tables: state.tables,
            }),
        },
    ),
)
